import { DateInput as AriaDateInput, DateInputProps as AriaDateInputProps, DateSegment } from 'react-aria-components';
import { tv } from 'tailwind-variants';

import { composeTailwindRenderProps } from '../../lib/styles';

const segmentStyles = tv({
  base: 'inline whitespace-nowrap type-literal:p-0 rounded-xs outline outline-0 caret-transparent [-webkit-tap-highlight-color:transparent]',
  variants: {
    isPlaceholder: {
      true: 'text-text-tertiary',
    },
    isDisabled: {
      true: 'text-text-disabled',
    },
    isFocused: {
      true: 'bg-blue-3 text-text-primary',
    },
  },
});

export const DateInputSegments = (props: Omit<AriaDateInputProps, 'children'>) => {
  return (
    <AriaDateInput {...props} className={composeTailwindRenderProps(props.className, 'outline-none')}>
      {(segment) => <DateSegment segment={segment} className={segmentStyles} />}
    </AriaDateInput>
  );
};
